const topics = [
  { label: '51cgfun最新', count: '2.3k' },
  { label: '官网入口', count: '1.8k' },
  { label: '域名变更', count: '1.6k' },
  { label: '访问方法', count: '1.4k' },
  { label: '安全提醒', count: '1.2k' },
  { label: '内容更新', count: '986' },
  { label: '使用教程', count: '872' },
  { label: '社区讨论', count: '754' },
  { label: '移动访问', count: '631' },
];

export default function TopicSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">社区中讨论度最高的51cg相关话题，了解大家都在关注什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#updates"
              className="group flex items-center gap-3 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer no-underline"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}